import { IconBase, IconComponent } from './BaseIcon';

export const Truck: IconComponent = (props) => (
  <IconBase {...props}>
    <path d="M27.06,8.41H21.88a3,3,0,0,0-3-2.76H5a3,3,0,0,0-3,3V23.5H5.12a4,4,0,0,0,7.64-.05h6.53A4,4,0,0,0,27,23.27v.18h3V13.79ZM10.93,22.35a2,2,0,1,1-2-2,2,2,0,0,1,2,2Zm12.19,2a2,2,0,1,1,2-2A2,2,0,0,1,23.12,24.35ZM28,21.45H27a4,4,0,0,0-7.78,0H12.82A4,4,0,0,0,5,21.5H4V8.65a1,1,0,0,1,1-1H18.89a1,1,0,0,1,1,1V15h2V10.41h4L28,14.29Z" />
  </IconBase>
);
